// src/components/HotelPage/HotelPage.jsx
import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import ZipcodeCheckSection from './ZipcodeCheckSection';
import PricingExplainer from './PricingExplainer';
import RoomList from '../Rooms/roomsList';

const HotelPage = () => {
  const { t } = useTranslation('common');
  const [zipValid, setZipValid] = useState(false);

  return (
    <>
      <Helmet>
        <title>{t('hotelPage.metaTitle')}</title>
        <meta
          name="description"
          content={t('hotelPage.metaDescription')}
        />
        <link rel="canonical" href="https://www.hotelmacarios.com.mx/hotel" />
      </Helmet>

      <ZipcodeCheckSection onResult={setZipValid} />
      <PricingExplainer />

      {zipValid ? (
        // RoomList ya trae su propio fondo, fecha, disponibilidad, selector
        // de perros y precio por cuarto - no hay que reconstruir nada de eso.
        <RoomList />
      ) : (
        <section className="bg-[#EFE6DD] py-16">
          <p className="text-center text-sm text-[#3A2A20]/50">
            {t('hotelPage.checkZipFirst')}
          </p>
        </section>
      )}
    </>
  );
};

export default HotelPage;